import {
  VolleyballAttributeId,
  VolleyballEventStatusId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { DetailsPanelSportConfiguration } from '../DetailsPanelSportConfigurationFactory'
import {
  VolleyballAttributesConfiguration,
  VolleyballDetailsConfiguration,
  VolleyballGroupName,
} from './VolleyballDetailsConfiguration'
import {
  VolleyballDetailsIncidentIds,
  VolleyballHideIncidentIds,
  VolleyballParticipantIncidentIds,
  VolleyballSecondParticipantIncidentIds,
} from './VolleyballFiltersIncidentIds'
import {
  VolleyballManualAddIncidentIds,
  VolleyballManualAddIncidentSubstitutionIds,
} from './VolleyballManualAddIncidentIds'
import { VolleyballManualAddStatusIds } from './VolleyballManualAddStatusIds'

export const VolleyballConfiguration: DetailsPanelSportConfiguration<
  VolleyballIncidentId,
  VolleyballAttributeId,
  VolleyballEventStatusId
> = {
  groupNames: VolleyballGroupName,
  detailsConfiguration: VolleyballDetailsConfiguration,
  attributesConfiguration: VolleyballAttributesConfiguration,
  secondParticipantIncidents: VolleyballSecondParticipantIncidentIds,
  filters: {
    hideIncidents: VolleyballHideIncidentIds,
    participantIncidents: VolleyballParticipantIncidentIds,
    detailsIncidents: VolleyballDetailsIncidentIds,
    selectedOnStartDetailsIncidents: VolleyballDetailsIncidentIds,
  },
  manualAddIncidentModal: {
    statuses: VolleyballManualAddStatusIds,
    incidents: VolleyballManualAddIncidentIds,
    substitutionIncidents: VolleyballManualAddIncidentSubstitutionIds,
  },
  showCurrentPeriodResult: true,
  reversePagination: true,
}
